// Configuration file that exports environment variables
// This allows for consistent access to environment variables throughout the app
//
// Every value below is supplied at build time from .env, which is generated from
// .env.deploy.tpl by deploy-frontend.sh / .github/workflows/deploy.yml.
//
// These deliberately have no fallback defaults. A build missing one of these is
// misconfigured, and a silent fallback would be worse than a loud failure — the
// previous defaults pointed at long-dead eu-west-1/salvinta.com infrastructure,
// and a fallback pointing at the test environment would risk a production build
// quietly reading and writing test data.

const required = (name: string, value: string | undefined): string => {
  if (!value) {
    throw new Error(
      `Missing required build-time environment variable ${name}. ` +
        `Check .env was generated from .env.deploy.tpl before building.`,
    );
  }
  return value;
};

// API Configuration
export const API_BASE_URL = required('VITE_API_BASE_URL', import.meta.env.VITE_API_BASE_URL);

// Cognito Configuration
export const COGNITO_USER_POOL_ID = required('VITE_COGNITO_USER_POOL_ID', import.meta.env.VITE_COGNITO_USER_POOL_ID);
export const COGNITO_CLIENT_ID = required('VITE_COGNITO_CLIENT_ID', import.meta.env.VITE_COGNITO_CLIENT_ID);
export const COGNITO_DOMAIN = required('VITE_COGNITO_DOMAIN', import.meta.env.VITE_COGNITO_DOMAIN);
export const COGNITO_REDIRECT_URI = required('VITE_COGNITO_REDIRECT_URI', import.meta.env.VITE_COGNITO_REDIRECT_URI);
export const COGNITO_LOGOUT_URI = required('VITE_COGNITO_LOGOUT_URI', import.meta.env.VITE_COGNITO_LOGOUT_URI);

// Region is the same for every environment, so a default is safe here.
export const COGNITO_REGION = import.meta.env.VITE_COGNITO_REGION || 'eu-central-1';

// Frontend Configuration
export const FRONTEND_URL = required('VITE_FRONTEND_URL', import.meta.env.VITE_FRONTEND_URL);
